import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Recaptcha } from './interface/Recaptcha.interface';
import { MatDialog } from '@angular/material';
import { DialogComponent } from '@shared/components/dialog/dialog.component';;
import { DialogConfirmChangeGeneralSettingsComponent } from '@shared/components/dialog/template/dialog-confirm-change-general-settings/dialog-confirm-change-general-settings.component';
import { LoaderService } from '@shared/components/loader/loader.service';
import { RecaptchaGeneralService } from '@app/services/general-settings/integrations/recaptcha/recaptcha.general.service';
import { convertToInt } from '@shared/utils/util';
import { ConfirmComponent } from '@shared/components/confirm/confirm.component';
import { ActivatedRoute } from '@angular/router';
import { RecaptchaPortalService } from '@app/services/general-settings/integrations/recaptcha/recaptcha.portal.service';
@Component({
  selector: 'app-recaptcha-integrator',
  templateUrl: './recaptcha-integrator.component.html',
  styleUrls: ['./recaptcha-integrator.component.scss']
})
export class RecaptchaIntegratorComponent implements OnInit {
  @Input()
  public integration: any;
  public form: FormGroup;
  public date: any;
  public loadButton = true;
  public lastState: Recaptcha;
  public dataSuccess: Boolean = false;
  public cascadeChanges = false;
  public changingCredentials: Boolean = false;
  public buttonVerify: Boolean = false;
  public count = 0;
  constructor(
    public formBuilder: FormBuilder,
    private dialog: MatDialog,
    private router: ActivatedRoute,
    private recaptchaGeneralService: RecaptchaGeneralService,
    private recaptchaPortalService: RecaptchaPortalService,
    private loaderService: LoaderService
  ) {}

  ngOnInit(): void {
    this.createForm();
    this.getData();

    this.form.valueChanges.subscribe((x: any) => {
      if (this.changingCredentials) {
        if (x.token && x.secret_key) {
          this.buttonVerify = true;
        }
      }
    });

  }

  getData() {
    if (this.integration === 'general') {
      this.recaptchaGeneralService.readBasic().subscribe(
        success => this.successData(success, 'find_config_to_main_setting'),
        error => this.errorData('Erro ao buscar os dados, entre em contato com o nosso suporte !')
      );
    }
    if (this.integration === 'portal') {
      this.recaptchaPortalService.read(this.router.snapshot.params.id).subscribe(
        success => this.successData(success, 'find_config_to_portal'),
        error => this.errorData('Erro ao buscar os dados, entre em contato com o nosso suporte !')
      );
    }
  }

  successData(success: any, variableError: string) {
    if (success.success) {
      this.dataSuccess = true;
      this.setValueForm(success.data);
      this.form.patchValue({
        validCaptcha: true
      })
      this.form.get('token').disable();
    } else {
      if (!success.data[variableError]) {
        this.changingCredentials = true;
        let obj = {
          token: '',
          secret_key: '',
          active: false,
          edited_by: null,
          type: null

        };
        this.setValueForm(obj);
      }
    }
  }

  errorData(message: string): void {
    this.loaderService.setChangesLoaderState(false,
      message,
      'ok',
      'error'
    );
  }

  onDialog(): void {
    if (this.integration == 'portal') {
      const state = this.dataSuccess ? 'alterar' : 'salvar';
      this.dialog.open(ConfirmComponent, {
        maxWidth: '60vw',
        width: '355px',
        minHeight: '210px',
        autoFocus: false,
        data: {
          title: 'Atenção',
          message: `Deseja realmente ${state} as configurações de captcha?`,
          btnOkText: 'Salvar',
          btnCancelText: 'Cancelar',
          reverseBtn: false
        },
        disableClose: false
      }).afterClosed().subscribe(success => {
        if (success) {
          this.onSubmit(0);
        }
      });
    }

    if (this.integration == 'general') {
      const dialog = this.dialog.open(DialogComponent, {
        width: '754px',
        height: '373px',
        data: {
          titleDialog: 'Atenção',
          titleButton: 'Salvar',
          component: DialogConfirmChangeGeneralSettingsComponent,
          cascadeChanges: this.cascadeChanges,
          headerRed: true
        },
        autoFocus: false,
        disableClose: true
      });
      dialog.beforeClosed().subscribe(
        resp => {
          if (typeof resp === 'boolean') {
            if (resp) {
              dialog.afterClosed().subscribe(
                result => {
                  this.onSubmit(convertToInt(result.data.cascade_change));
                }
              );
            }
          }
        }
      );
    }
  }

  createElement(): HTMLElement {
    const widgets = document.getElementById("widgets");
    const widget = document.createElement('div');
    widgets.appendChild(widget);
    widget.id = `widget-${this.count}`;
    widget.style.visibility = 'hidden'
    widget.style.position = 'absolute'
    widget.style.top = '-9999px'
    this.count++;
    return widget;
  }

  validTokenCaptcha(recaptcha: Recaptcha): Promise<void> {
    let error = false;
    return new Promise((resolve, reject) => {
      const baseOptions = {
        sitekey: recaptcha.token,
        'error-callback': () => {
          error = true;
          widget.remove();
          reject();
        },
      };
      const widget = this.createElement();
      window['grecaptcha'].render(widget, baseOptions);
      setTimeout(() => {
        if (!error) {
          widget.remove();
          resolve();
        }
      }, 500);
    })
  }

  resetValidation(): void {
    if (!this.changingCredentials) {
      this.form.get('token').enable();
      this.changingCredentials = true;
      this.form.patchValue({
        ...this.lastState,
        validCaptcha: null
      });
    } else {
      this.clearFields()
    }
  }

  changeCredentials(): void {
    if (this.changingCredentials) {
      this.changingCredentials = false;
      this.form.patchValue({
        ...this.lastState,
        validCaptcha: true
      });
      this.form.get('token').disable();
    } else {
      this.form.get('token').enable();
      this.changingCredentials = true;
      this.buttonVerify = false;
      this.clearFields();
    }
  }

  clearFields(): void {
    const obj = {
      token: this.lastState.token ??  '',
      secret_key: this.lastState.secret_key ??  '',
      type: null,
      active: false,
      validCaptcha: null
    }
    this.form.patchValue(obj);
  }

  private createForm(): void {
    this.form = this.formBuilder.group({
      id: [null],
      secret_key: [null],
      token: [null],
      type: [null],
      active: [null],
      last_change: [null],
      changed_by: [null],
      validCaptcha: [null, Validators.required],
    });
  }

  private setValueForm(data: any): void {
    this.lastState = data;
    this.form.controls.last_change.setValue(data.updated_at);
    this.form.controls.changed_by.setValue(data.edited_by);
    this.date = {
      last_change: data.updated_at,
      changed_by: data.edited_by
    }
    this.form.patchValue(data);
  }

  verifyCredentials(): void {
    const recaptcha: Recaptcha = this.form.getRawValue();
    this.recaptchaGeneralService.verifyCrendentials(recaptcha).subscribe(
      success => {
        if (!success.success) {
          if (success.data == 'invalid-input-secret') {
            this.errorData('Captcha inválido, ou o domínio não está configurado corretamente.');
          } else {
            this.errorData('Não foi possível verificar as configurações para o captcha.');
          }
          this.form.patchValue({
            validCaptcha: null
          })
        } else {
          this.verifyToken(recaptcha);
        }
      },
      error => this.errorData('Não foi possível verificar as configurações para o captcha.')
    )
  }

  verifyToken(recaptcha: Recaptcha): void {
    this.validTokenCaptcha(recaptcha).then(() => {
      this.form.patchValue({
        validCaptcha: true
      })
      this.loaderService.setChangesLoaderState(false,
        'Captcha validado com sucesso!',
        'ok',
        'success'
      );
    }).catch(() => {
      this.form.patchValue({
        validCaptcha: null
      })
      this.errorData('Captcha inválido, ou o domínio não está configurado corretamente.');
    });
  }

  onSubmit(cascade_change: Number): void {
    const recaptcha = this.form.getRawValue();
    if (!this.changingCredentials) {
      delete recaptcha.token;
      delete recaptcha.secret_key;
    }
    recaptcha.type = "normal";
    if (this.integration == 'general') {
      this.onSubmitedGeneral(recaptcha, cascade_change)
    }

    if (this.integration == 'portal') {
      this.onSubmitedPortal(recaptcha)
    }

  }

  onSubmitedGeneral(recaptcha, cascade_change): void {
    recaptcha.cascade_change = cascade_change;
    this.recaptchaGeneralService.create(recaptcha).subscribe(
      success => {
        if (success.success) {
          this.setValueForm(success.data);
          this.form.get('token').disable();
          this.changingCredentials = false;
          this.dataSuccess = true;
          this.loaderService.setChangesLoaderState(false,
            'Captcha salvo com sucesso.',
            'ok',
            'success'
          );
        } else {
          if (success.data == 'invalid-input-secret') {
            this.errorData('A chave secreta parece estar inválida. Tente inseri-la novamente.');
          } else {
            this.errorData('Não foi possível salvar as configurações para o captcha.');
          }
        }
      },
      error => this.errorData('Não foi possível salvar as configurações para o captcha.')
    );
  }

  onSubmitedPortal(recaptcha: any): void {
    recaptcha.portal_id = this.router.snapshot.params.id;
    this.recaptchaPortalService.create(recaptcha).subscribe(
      success => {
        if (success.success) {
          this.setValueForm(success.data);
          this.form.get('token').disable();
          this.changingCredentials = false;
          this.dataSuccess = true;
          this.loaderService.setChangesLoaderState(false,
            'Captcha salvo com sucesso.',
            'ok',
            'success'
          );
        } else {
            this.errorData('Não foi possível salvar as configurações para o captcha.');
        }

      },
      error => this.errorData('Não foi possível salvar as configurações para o captcha')
    );
  }

}
